import { useState } from 'react';
import { Box } from 'reflexbox';
import styled from 'styled-components';
import { rgba } from 'polished';
import { useField } from 'formik';

import * as graphql from 'generated/graphql';
import EditIcon from 'packages/kakapo-ui-kit/assets/icons/EditIcon';

const TalentReviewLabelField = styled(Box)<{
	editing: boolean;
	multiline?: boolean;
	vertical?: boolean;
}>`
	white-space: pre;
	cursor: text;
	max-width: ${(props) => (props.multiline ? 160 : 120)}px;
	overflow: hidden;
	text-overflow: ellipsis;
	text-align: center;
	line-height: 20px;

	${(props) =>
		props.multiline &&
		`
		white-space: normal;
		word-wrap: wrap;
	`}

	svg {
		display: block;
	}

	${(props) =>
		props.vertical &&
		`
		position: absolute;
		left: 50%;
		transform: translateX(-50%) translateY(-50%) rotateZ(-90deg);
		transition: .4s cubic-bezier(0.16, 1, 0.3, 1) transform;
`}

	${(props) =>
		props.editing
			? `
		background: white;
		border: 1px solid ${props.theme.colors.primary};
		margin: -1px;
		border-radius: 4px;
		box-shadow: 0px 1px 6px ${rgba(props.theme.colors.primary, 0.6)};
		outline: none !important;
		color:black;
		${props.vertical && `transform: translateX(-50%) translateY(-50%);`}
		z-index: 2;
		text-overflow: clip;
	`
			: `
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		max-height: 54px;
		overflow: hidden;
		border: 1px solid transparent;
		text-overflow: clip;

		&:hover {
			background: white;
			border: 1px solid ${props.theme.colors.lightBlue};
			border-radius: 4px;
			box-shadow: 0px 1px 6px ${rgba(props.theme.colors.lightBlue, 0.25)};
			color: ${props.theme.colors.slateBlue};

			// ${!props.vertical && `margin: -1px;`}

			g {
				fill: ${props.theme.colors.slateBlue};
			}
		}
	`}
`;

export default function TalentReviewLabel(props: {
	multiline?: boolean;
	hex: string;
	name: string;
	vertical?: boolean;
}) {
	const [editing, setEditing] = useState(false);

	const [{ value: languageID }] = useField<string>('languageID');
	const [{ value }, , { setValue }] = useField<graphql.LocalizedString>(props.name ?? 'unknown');

	const text = value?.find((text) => text.languageID === languageID)?.text;

	return (
		<TalentReviewLabelField
			multiline={props.multiline}
			editing={editing}
			vertical={props.vertical}
			px={3}
			py={2}
			tabIndex={-1}
			contentEditable={editing}
			suppressContentEditableWarning
			onMouseDown={(event) => {
				setEditing(true);
				event.stopPropagation();
			}}
			onKeyDown={(event) => event.key === 'Enter' && event.currentTarget.blur()}
			onBlur={(event) => {
				event.currentTarget.scrollTo(0, 0);

				const rest = value?.filter((text) => text.languageID !== languageID) ?? [];
				setValue([
					...rest,
					{
						languageID,
						text: event.currentTarget.textContent ?? '',
					},
				]);
				setEditing(false);
			}}
		>
			{text || (!editing && <EditIcon color={props.hex} />)}
		</TalentReviewLabelField>
	);
}
